export const CURRENT_USER = 'currentUser';
export const USER_INFO = 'userProfile';
export const IS_AUTHENTICATED = 'isAuth';
export const SET_CURRENT_USER = 'setCurrentUser';
export const SET_USER_INFO = 'setUserProfile';

export const LOGIN_LOADING = 'loginLoading';
export const LOGIN_SUCCESS = 'loginSuccess';
export const LOGIN_ERROR = 'loginError';
export const LOGOUT_ERROR = 'logoutError';
export const SET_LOGIN_LOADING = 'setLoginLoading';
export const SET_LOGIN_SUCCESS = 'setLoginSuccess';
export const SET_LOGIN_ERROR = 'setLoginError';
export const SET_LOGOUT_ERROR = 'setLogoutError';

export const CATEGORIES = 'categories';
export const SET_CATEGORIES = 'setCategories';

export const CURRENCIES = 'currencies';
export const SET_CURRENCIES = 'setCurrencies';

export const TAGS = 'tags';
export const TAGS_PAGINATION = 'tagsPagination';

export const SET_TAGS = 'setTags';
export const SET_TAGS_PAGINATION = 'setTagsPagination';
